import React, { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteStatusContext = React.createContext({
  paused: false,
  loading: true,
  refresh: () => {},
  setPaused: () => {},
});

export function SiteStatusProvider({ children }) {
  const [paused, setPausedState] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site/status");
      setPausedState(!!data.paused);
    } catch {
      /* ignore — leave previous value */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30_000);
    return () => clearInterval(t);
  }, [refresh]);

  // Called by the admin after a successful PATCH so the UI updates instantly
  // without waiting for the 30s poll.
  const setPaused = useCallback((val) => setPausedState(!!val), []);

  return (
    <SiteStatusContext.Provider value={{ paused, loading, refresh, setPaused }}>
      {children}
    </SiteStatusContext.Provider>
  );
}

export function useSiteStatus() {
  return React.useContext(SiteStatusContext);
}
